import Card from "../../shared/Card/Card";
import NotesOutput from "../../shared/Notes/NotesOutput";
import { ResourceType } from "../../../models/Note";
import { IPart } from "../../../models/Part";

export default function StockNotes({ part }: { part: IPart }) {
  const buyerNotes = part.offers.at(0)?.buyerCheckoutNotes ?? null;

  return (
    <div className="flex flex-col gap-4">
      <Card
        title="Part Condition Notes"
        subtitle="These notes appear on the public listing"
        bodyClassName="px-2 pb-4"
      >
        <NotesOutput
          resourceId={part.id}
          resourceType={ResourceType.Part}
          shouldScroll={false}
          notes={part.notes ?? []}
        />
      </Card>

      <Card
        title="Internal Part Notes"
        subtitle="Only visible to staff — never appears on the listing"
        bodyClassName="px-2 pb-4"
      >
        <NotesOutput
          resourceId={part.id}
          resourceType={ResourceType.InternalPart}
          shouldScroll={false}
          notes={part.internalNotes ?? []}
        />
      </Card>

      <Card
        title="Buyer Notes"
        subtitle="Notes left by the buyer at checkout"
        bodyClassName="px-6 pb-4 py-5"
      >
        {buyerNotes ? (
          <p className="whitespace-pre-wrap break-words text-sm text-gray-800">
            {buyerNotes}
          </p>
        ) : (
          <p className="text-sm italic text-gray-400">
            No buyer notes provided.
          </p>
        )}
      </Card>
    </div>
  );
}
